module.exports = __webpack_public_path__ + "img/oni_frame_holder_body.7a75f1fb.png";